<script lang="ts">
	import { flip } from 'svelte/animate';
	import { dndzone } from 'svelte-dnd-action';
	import SearchWithSorting from './Mix/SearchWithSorting.svelte';
	import type { Item } from 'DragNDrop';

	export let items: Item[];
	export let containerWidth = '100%';
	export let itemWidth = 'auto';
	export let logical: boolean;
	export let hasfilter = false;
	export let input: boolean;
	let itemsBaseFirstTime = true;
	let itemsBase = [];

	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	let valid = true;
	let filter = '';
	const flipDurationMs = 100;

	function onSearchSortingChange(sortedItems: Item[]) {
		items = sortedItems;
	}

	function handleDndConsider(e: CustomEvent) {
		items = e.detail.items;
	}

	function handleDndFinalize(e: CustomEvent) {
		if (logical) {
			const index = e.detail.items[0].id + 10;
			items = [
				{ id: index, name: 'and', type: 1 },
				{ id: index + 1, name: 'or', type: 1 },
				{ id: index + 2, name: '()', type: 1 },
				{ id: index + 3, name: 'not()', type: 1 }
			];
		} else if (!input) {
			const newItems = [];
			itemsBase.forEach((item, i) => {
				newItems.push({ id: i, name: item.name, type: 2 });
			});
			items = newItems;
		} else {
			items = e.detail.items;
			e.detail.items.forEach((el: Item) => {
				if (el.name === 'not()') {
					let notIndex = items.findIndex((x) => x.name === 'not()');
					let notCopy = [...items];
					if (notIndex !== -1) {
						const id = notCopy[notIndex].id;
						notCopy.splice(notIndex, 1);
						notCopy.splice(notIndex, 0, { id: id, name: 'not', type: 1 });
						notCopy.splice(notIndex + 1, 0, { id: id + 1, name: '(', type: 1 });
						notCopy.splice(notIndex + 2, 0, { id: id + 2, name: ')', type: 1 });
					}
					items = notCopy;
				}
				if (el.name === '()') {
					let foundIndex = items.findIndex((x) => x.name === '()');
					let copy = [...items];
					if (foundIndex !== -1) {
						const id = copy[foundIndex].id;
						copy.splice(foundIndex, 1);
						copy.splice(foundIndex, 0, { id: id, name: '(', type: 1 });
						copy.splice(foundIndex + 1, 0, { id: id + 1, name: ')', type: 1 });
					}
					items = copy;
				}
			});

			validate();
			if (input && valid) {
				var string = '';
				items.forEach((element) => {
					string += element.name + ' ';
				});
				dispatch('parseQuery', {
					text: string
				});
			}
		}
	}

	function checkBrackets(str: string) {
		if (
			str.includes('and and') ||
			str.includes('or or') ||
			str.includes('and or') ||
			str.includes('or and') ||
			str.startsWith('or') ||
			str.startsWith('and') ||
			str.startsWith('not not')
		) {
			return false;
		}
		var depth = 0;
		const newStr = str.split(' ');
		for (var i in newStr) {
			if (newStr[i] == '(') {
				depth++;
			} else if (newStr[i] == ')') {
				depth--;
			}
			if (depth < 0) return false;
		}
		if (depth > 0) return false;
		return true;
	}

	function validate() {
		if (input) {
			var string = '';
			items.forEach((element) => {
				string += element.name + ' ';
			});
			valid = checkBrackets(string);
		}
	}

	$: {
		if (itemsBaseFirstTime && items.length > 0) {
			itemsBase = items;
			itemsBaseFirstTime = false;
		}
	}
</script>

{#if hasfilter}
	<SearchWithSorting {items} {onSearchSortingChange} bind:filter />
{/if}
<section
	style="width:{containerWidth}"
	class={logical ? '' : 'smallSection'}
	autoAriaDisabled={true}
	use:dndzone={{ items, flipDurationMs, autoAriaDisabled: true }}
	on:consider={handleDndConsider}
	on:finalize={handleDndFinalize}
>
	{#each items as item (item.id)}
		<div
			style="width:{itemWidth}"
			animate:flip={{ duration: flipDurationMs }}
			class="{item.type === 1 ? 'logical' : 'basic'} {item.name.toLowerCase().includes(filter) ||
			item.type === 1
				? 'filtered'
				: 'filteredOut'}"
		>
			{item.name}
		</div>
	{/each}
</section>
{#if !valid}
	Error
{/if}

<style>
	section {
		padding: 0.3em;
	}

	.smallSection {
		min-height: 60px;
	}

	div {
		height: 45px;
		display: inline-block;
		padding: 0.9em;
		margin: 4px 0.15em;
	}

	.logical {
		border: 1px solid var(--mdc-theme-primary);
		color: var(--mdc-theme-primary);
		background-color: white;
		border-radius: 8px;
		font-weight: bold;
	}

	.basic {
		background-color: var(--mdc-theme-primary);
		color: white;
		border-radius: 8px;
	}

	.filtered {
		display: inline-block;
	}

	.filteredOut {
		display: none;
	}
</style>
